<div class="h100">
    <div class="d-flex h100">
        <div class="side-bar h100 relative">
            <div class="vertical-flex h100">
                <div class="footer-icon">
                    <div class="brand">
                        <img src="assets/images/logo.svg" alt="">
                    </div>
                </div>
                <ng-container *ngIf="appSetting.environment.region !== 'global'">
                    <div class="flag bt-1">
                        <img src="assets/flag/{{appSetting.environment.region}}.png" />
                        <p class="text-capitalize">{{appSetting.environment.region}}</p>
                    </div>
                </ng-container>
                <div class="footer-icon bt-1">
                    <div class="avatar" [matMenuTriggerFor]="profileMenu">
                        <img src="assets/images/galaxy.jpg" alt="">
                        <div class="text capitalize">
                            {{loginName?.firstName.charAt(0)}}
                        </div>
                    </div>
                </div>
                <button mat-icon-button class="menu-item" [appMegaMenu]="adminmenu" appMenuAccess="AdministrationMenu">
                    <ion-icon name="person-outline"></ion-icon>
                </button>
                <button mat-icon-button class="menu-item" [appMegaMenu]="insurancemenu"
                    appMenuAccess="InsuranceCompanyMenu">
                    <ion-icon name="pricetags-outline"></ion-icon>
                </button>
                <button mat-icon-button class="menu-item" [appMegaMenu]="lossmenu" appMenuAccess="LossPercentageMenu">
                    <ion-icon name="receipt-outline"></ion-icon>
                </button>
                <button mat-icon-button class="menu-item" [appMegaMenu]="cooperativecompany"
                    appMenuAccess="CooperativeMenu">
                    <ion-icon name="document-outline"></ion-icon>
                </button>
                <button mat-icon-button class="menu-item" [appMegaMenu]="Unadminreports" appMenuAccess="ReportMenu">
                    <ion-icon name="document-text-outline"></ion-icon>
                </button>
                <div class="flex-1 relative">
                    <div class="ab">
                        <!--  -->
                        <!-- <button mat-icon-button class="menu-item" matTooltip="User" matTooltipPosition="right"
                                [routerLink]="['home/user']" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}" appMenuAccess="UserMenu">
                                <ion-icon name="person-outline"></ion-icon>
                            </button> -->
                        <!-- <div class="rel">

                       
                            <button mat-icon-button class="menu-item" appPopover="User" [routerLink]="['home/user']"
                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                                appMenuAccess="UserMenu">
                                <ion-icon name="person-outline"></ion-icon>
                            </button>
                            <button mat-icon-button class="menu-item" appPopover="Branch"
                                [routerLink]="['home/branch']" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}" appMenuAccess="BranchMenu">
                                <ion-icon name="git-merge-outline"></ion-icon>
                            </button>
                            <button mat-icon-button class="menu-item" appPopover="Product"
                                [routerLink]="['home/product']" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}" appMenuAccess="ProductMenu">
                                <ion-icon name="pricetags-outline"></ion-icon>
                            </button>
                            <button mat-icon-button class="menu-item" appPopover="Member"
                                [routerLink]="['home/member']" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}" appMenuAccess="MemberMenu">
                                <ion-icon name="people-outline"></ion-icon>
                            </button>
                            <button mat-icon-button class="menu-item" appPopover="Application Group"
                                [routerLink]="['home/pre-application']" routerLinkActive="active"
                                [routerLinkActiveOptions]="{exact: true}" appMenuAccess="PreApplicationMenu">
                                <ion-icon name="document-outline"></ion-icon>
                            </button>
                            <button mat-icon-button class="menu-item" appPopover="Onboard Application"
                                [routerLink]="['home/onboard-application']" appMenuAccess="PreApplicationMenu"
                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                      
                                <ion-icon name="documents-outline"></ion-icon>
                            </button>

                            <button mat-icon-button class="menu-item" appPopover="Customer Application"
                                [routerLink]="['home/customer']" routerLinkActive="active"
                                appMenuAccess="CustomerApplicationMenu" [routerLinkActiveOptions]="{exact: true}">
                               
                                <ion-icon name="people-circle-outline"></ion-icon>
                            </button>
                            <button mat-icon-button class="menu-item" appPopover="Upload Error"
                                [routerLink]="['home/upload-error']" routerLinkActive="active"
                                appMenuAccess="UploadErrorMenu" [routerLinkActiveOptions]="{exact: true}">
                                <ion-icon name="alert-circle-outline"></ion-icon>
                            </button>
                            
                           
                            <button mat-icon-button class="menu-item" appPopover="WRMS Event Info"
                                [routerLink]="['home/wrms-event-search']" routerLinkActive="active"
                                appMenuAccess="CustomerApplicationMenu" [routerLinkActiveOptions]="{exact: true}">
                                <ion-icon name="documents-outline"></ion-icon>
                            </button>
                            <button mat-icon-button class="menu-item" appPopover="Member Policy"
                                [routerLink]="['home/member-policy']" routerLinkActive="active"
                                appMenuAccess="CustomerApplicationMenu" [routerLinkActiveOptions]="{exact: true}">
                                <ion-icon name="reader-outline"></ion-icon>
                            </button>
                            <button mat-icon-button class="menu-item" appPopover="Member Payout"
                                [routerLink]="['home/member-payout']" routerLinkActive="active"
                                appMenuAccess="CustomerApplicationMenu" [routerLinkActiveOptions]="{exact: true}">
                                <ion-icon name="receipt-outline"></ion-icon>
                            </button>
                        </div> -->

                        <button mat-icon-button class="menu-item" appPopover="Insurance" [routerLink]="['/home/insurance']"
                            routerLinkActive="active" appMenuAccess="InsuranceMenu"
                            [routerLinkActiveOptions]="{exact: true}">
                            <ion-icon name="pricetags-outline"></ion-icon>
                        </button>
                        <button mat-icon-button class="menu-item" appPopover="Cooperative Societies"
                            [routerLink]="['/home/cooperative']" routerLinkActive="active"
                            appMenuAccess="CooperativeSocietiesMenu" [routerLinkActiveOptions]="{exact: true}">
                            <ion-icon name="people-outline"></ion-icon>
                        </button>
                        <button mat-icon-button class="menu-item" appPopover="My Applications"
                            [routerLink]="['/home/my-policy']" routerLinkActive="active" appMenuAccess="MyPolicyMenu"
                            [routerLinkActiveOptions]="{exact: true}">
                            <ion-icon name="document-outline"></ion-icon>
                        </button>
                        <button mat-icon-button class="menu-item" appPopover="New Application"
                            [routerLink]="['/home/insurance-providers-onboard']" routerLinkActive="active"
                            appMenuAccess="MOnboardApplicationMenu" [routerLinkActiveOptions]="{exact: true}">
                            <ion-icon name="documents-outline"></ion-icon>
                        </button>
                        <button mat-icon-button class="menu-item" appPopover="My Profile"
                            [routerLink]="['/home/profile']" routerLinkActive="active" appMenuAccess="MyProfilenMenu"
                            [routerLinkActiveOptions]="{exact: true}">
                            <ion-icon name="person-outline"></ion-icon>
                        </button>
                        <button mat-icon-button class="menu-item" appPopover="Location Verification"
                            [routerLink]="['/home/location-verification']" routerLinkActive="active"
                            appMenuAccess="LocationVerificationMenu" [routerLinkActiveOptions]="{exact: true}">
                            <ion-icon name="documents-outline"></ion-icon>
                        </button>
                        <button mat-icon-button class="menu-item" appPopover="Organization"
                            [routerLink]="['/home/organization']" routerLinkActive="active"
                            appMenuAccess="organizationMenu" [routerLinkActiveOptions]="{exact: true}">
                            <ion-icon name="business-outline"></ion-icon>
                        </button>
                        <!-- <button mat-icon-button class="menu-item" appPopover="Organization"
                                [routerLink]="['home/organization']"
                                routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                                <ion-icon name="business-outline" appMenuAccess="organizationMenu"></ion-icon>
                            </button> -->
                    </div>
                </div>
            </div>

        </div>

        <div class="flex-1 h100 relative overflow-hidden">
            <div class="vertical-flex h100">
                <div class="flex-1 h100 relative">
                    <router-outlet></router-outlet>
                </div>
                <app-message-box [expandTrue]="data.messageBoxExpandTrue"></app-message-box>

            </div>

        </div>

    </div>

</div>
<mat-menu #profileMenu="matMenu" xPosition="after" yPosition="below">
    <div class="profile-menu-container">
        <div class="p-3">
            <div class="d-flex align-item-center">
                <div class="avatar">
                    <img src="assets/images/galaxy.jpg" alt="">
                    <div class="text capitalize">
                        {{loginName?.firstName.charAt(0)}}
                    </div>
                </div>
                <div class="profile-text capitalize">
                    <h4>{{loginName?.firstName}} {{loginName?.middleName}} {{loginName?.lastName}}</h4>
                    <p class="pt-1">
                        <ng-container *ngIf="user?.designationDescription !== ''">
                            {{user?.designationDescription}}
                        </ng-container>
                        <ng-container *ngIf="user?.organizationName !== ''">
                            - {{user?.organizationName}}
                        </ng-container>
                    </p>
                </div>
            </div>
        </div>
        <!-- <button mat-menu-item>My Profile</button> -->
        <!-- <button mat-menu-item>Settings</button> -->
        <button mat-menu-item (click)="openChangePassword()">Change Password</button>
        <button mat-menu-item (click)="confirmLogout()">Logout</button>
        <div class="p-3 op5">
            <small>Last Login
                {{user?.iUserAdditionalDetail.lastLoginDatetime | appDate: 'datetime'}}
                <!-- :appSetting.environment.dateViewFormatWithTime -->
            </small>
        </div>
    </div>
</mat-menu>

<ng-template #adminmenu>
    <div class="dialog-cover">
        <div class="app-mega-menu">
            <div class="menu-panel">
                <div class="menu-block">
                    <div class="main-menu">
                        <ul>
                            <li class="menu-title">Administration</li>
                            <li appMenuAccess="UserMenu">
                                <a href="home/user">User</a>
                            </li>
                            <li appMenuAccess="UserMenu">
                                <a href="home/branch">Branch</a>
                            </li>
                            <li appMenuAccess="ProductMenu">
                                <a href="home/product">Product</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #insurancemenu>
    <div class="dialog-cover">
        <div class="app-mega-menu">
            <div class="menu-panel">
                <div class="menu-block">
                    <div class="main-menu">
                        <ul>
                            <li class="menu-title">Insurance Company</li>
                            <li appMenuAccess="CustomerApplicationMenu">
                                <a href="home/customer">Customer Application</a>
                            </li>
                            <li appMenuAccess="UploadPolicyMenu">
                                <a href="home/upload-policy">Upload Policy</a>
                            </li>
                            <li appMenuAccess="PolicySearchMenu">
                                <a href="home/policy-search">Policy Search</a>
                            </li>

                            <li appMenuAccess="DownloadLossInfoMenu">
                                <a href="home/download-loss-info">Download Loss Info</a>
                            </li>

                            <li appMenuAccess="UpdatePayoutMenu">
                                <a href="home/upload-payout">Update Payout</a>
                            </li>
                            <li appMenuAccess="PayoutSearchMenu">
                                <a href="home/payout-search">Payout Search</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #lossmenu>
    <div class="dialog-cover">
        <div class="app-mega-menu">
            <div class="menu-panel">
                <div class="menu-block">
                    <div class="main-menu">
                        <ul>
                            <li class="menu-title">Loss Percentage Computation</li>
                            <li>
                                <a href="home/download-active-members">Download Active Member</a>
                            </li>
                            <li>
                                <a href="home/upload-loss-percentage">Upload Loss Percentage</a>
                            </li>
                            <li>
                                <a href="home/loss-percentage">Loss Percentage Search</a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #cooperativecompany>
    <div class="dialog-cover">
        <div class="app-mega-menu">
            <div class="menu-panel">
                <div class="menu-block">
                    <div class="main-menu">
                        <ul>
                            <li class="menu-title">Cooperative Company</li>
                            <li appMenuAccess="MemberMenu">
                                <a href="home/member">Member</a>
                            </li>
                            <li appMenuAccess="PreApplicationMenu">
                                <a href="home/pre-application">Application Group</a>
                            </li>
                            <li appMenuAccess="PreApplicationMenu">
                                <a href="home/onboard-application">Onboard Application</a>
                            </li>
                            <li appMenuAccess="UploadErrorMenu">
                                <a href="home/upload-error">Upload Error</a>
                            </li>
                            <!-- <li appMenuAccess="LocationVerificationMenu">
                                <a href="/home/location-verification">Location Verification</a>
                            </li> -->
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #Unadminreports>
    <div class="dialog-cover">
        <div class="app-mega-menu">
            <div class="menu-panel">
                <div class="menu-block">
                    <div class="main-menu">
                        <ul>
                            <li class="menu-title">Reports</li>
                            <li appMenuAccess="MRReportMenu">
                                <a href="home/member-registration-report">Member Registration Report</a>
                            </li>
                            
                            <li appMenuAccess="MRReportMenu" *ngIf="appSetting.environment.getInsurmet === true">
                                <a href="home/member-loss-report">Member Loss Computation Detail</a>
                            </li>
                        </ul> 
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>